import { WhatsAppOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import { PersonAddIcon, PersonOutlineIcon } from 'common/icons';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'src/auth';
import { Organization } from 'src/pages/organization/organization.model';

import { ActionsList } from '../actions-list/actions-list.component';
import { OnboardingAction } from '../actions-list/actions-list.model';
import {
  getAccountMembersUrl,
  getAccountWorkspacesUrl,
} from '../actions-list/actions-list.util';
import { supportWhatsappLink } from './onboarding-failed.constant';
import * as Styled from './onboarding-failed.style';

const { Title, Paragraph } = Typography;

interface OnboardingFailedViewProps {
  organization: Organization | null;
}

const OnboardingFailedView = ({ organization }: OnboardingFailedViewProps) => {
  const { t } = useTranslation();
  const { user } = useAuth();

  const userName = user?.first_name || user?.name || t('common.user');

  const actions: OnboardingAction[] = [
    {
      id: 'invite',
      label: t('onboarding.action.invite'),
      icon: <PersonAddIcon />,
      onClick: () =>
        window.open(
          getAccountMembersUrl(
            organization?.workspace_id || '',
            organization?.id || '',
          ),
          '_blank',
        ),
    },
    {
      id: 'account',
      label: t('onboarding.action.account'),
      icon: <PersonOutlineIcon />,
      onClick: () =>
        window.open(
          getAccountWorkspacesUrl(
            organization?.workspace_id || '',
            organization?.id || '',
          ),
          '_blank',
        ),
    },
    {
      id: 'support',
      label: t('onboarding.action.support'),
      icon: <WhatsAppOutlined />,
      onClick: () => {
        const newWindow = window.open(
          supportWhatsappLink,
          '_blank',
          'noopener,noreferrer',
        );
        if (newWindow) newWindow.opener = null;
      },
    },
  ];

  return (
    <Styled.FailedWrapper>
      <Styled.ImageContainer>
        <Styled.SceneImage
          style={{
            backgroundImage: `url('/assets/something-went-wrong.png')`,
          }}
        />
      </Styled.ImageContainer>
      <Styled.ContentLayout>
        <Styled.LeftContent>
          <Title level={4}>
            {t('onboarding.failed.title', { name: userName })}
          </Title>
          <Paragraph>{t('onboarding.failed.duration')}</Paragraph>
          <Paragraph>{t('onboarding.failed.description')}</Paragraph>
        </Styled.LeftContent>

        <Styled.RightContent>
          <ActionsList actions={actions} />
        </Styled.RightContent>
      </Styled.ContentLayout>
    </Styled.FailedWrapper>
  );
};

export { OnboardingFailedView };
